export default __webpack_public_path__ + "static/media/signature_logo.61e3fd4f.png";